module.exports = __webpack_public_path__ + "img/image-01.f532d78f.webp";